<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        :date="time.start"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3946.054062193416!2d115.10058571478287!3d-8.49412479389302!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd22513c060a0a7%3A0x2d7646bdf28858e5!2sArya%20%26%20Ari!5e0!3m2!1sen!2sid!4v1583639431426!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//Arya+%26+Ari,+Jl.+Sarasidi,+Sembung+Gede,+Kec.+Kerambitan,+Kabupaten+Tabanan,+Bali+82161/@-8.4941248,115.1005857,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x2dd22513c060a0a7:0x2d7646bdf28858e5!2m2!1d115.1027744!2d-8.4941248!3e0"
        :location="location"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/_DSC8810___lHd-7ffWe.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/_DSC8907___FMhy6Y3Kxc.jpg'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/_DSC8984___BoQrlPr1f.jpg'
const ImageHero4 = 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/_DSC9061___bPquNM6ZV.jpg'

import Audio from "@/assets/audio/gus-teja-awan-putih.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pawiwahan / Pernikahan',
      backgrounds: [ImageHero1, ImageHero2, ImageHero3, ImageHero4],
      bgActive: 0,
      dividerHeight: 0,
      location: "Br. Sarasidi, Ds. Sembung Gede, Kec. Kerambitan, Kab. Tabanan - Bali",
      time: {
        start: this.$moment("08 April 2020 11:00"),
        end: "Selesai"
      },
      wedding: {
        man: {
          name: 'I Wayan Arya Wisma',
          surname: 'Arya',
          parents: 'I Nengah Watra (Alm) & Ni Made Astiti',
          description: 'Putra pertama',
          address: 'Br. Sarasidi, Ds. Sembung Gede, Kec Kerambitan, Kab. Tabanan - Bali',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/arya_T8o8QP4Urk.jpg?tr=w-300',
        },
        woman: {
          name: 'Ni Made Ari Aristayanti, Amd. Keb',
          surname: 'Ari',
          parents: 'I Gede Giri Suyasa & Ni Nengah Kerwi',
          address: 'Br. Bukit Kelod, Ds. Bukit, Kec. Karangasem, Kab. Karangasem - Bali',
          description: 'Putri kedua',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/arya-ari/ari_N20_RsReo.jpg?tr=w-300',
        },
      },
      mepandes: [
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
